/**
 * config 파일
 */
export const CONFIG = {
  NODE_ENV: process.env.NODE_ENV,
  CAFE24_API_HOST: process.env.VUE_APP_CAFE24_API_HOST,
  API_HOST: process.env.VUE_APP_API_HOST,
  CLIENT_SECRET: process.env.VUE_APP_ASA_CLIENT_SECRET,
  CLIENT_ID: process.env.VUE_APP_ASA_CLIENT_ID,
  VERSION: process.env.VUE_APP_ASA_VERSION,
};
